import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { products } from "@/mocks/products";

export default function ProductShowcase() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  // Pick 8 featured products: one from each of the first 8 categories
  const featured = products.slice(0, 8);

  return (
    <section className="py-16 bg-white" id="products">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
            {t("home.products.title")}
          </h2>
        </div>
        <p className="text-gray-600 mb-8">{t("home.products.subtitle")}</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
          {featured.map((product) => (
            <a
              key={product.id}
              href={product.link}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow duration-300"
              data-product-shop
            >
              <div className="aspect-square overflow-hidden bg-gray-100 relative">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
              </div>
              <div className="p-3 md:p-4">
                <p className="text-xs font-medium text-emerald-700 mb-1">
                  {product.category}
                </p>
                <h3 className="text-sm font-medium text-gray-900 leading-snug line-clamp-2 mb-2 min-h-[2.5rem]">
                  {product.name}
                </h3>
                <p className="text-sm font-bold text-emerald-700 mb-3">
                  {product.price}
                </p>
                <span className="inline-flex items-center justify-center w-full px-3 py-2 bg-emerald-700 text-white text-sm font-medium rounded-lg hover:bg-emerald-800 transition-colors">
                  <i className="ri-shopping-bag-line mr-1.5" />
                  {t("products.buyNow")}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to={`/${currentLang}/products`}
            className="inline-flex items-center gap-2 px-8 py-3 bg-emerald-700 text-white font-semibold rounded-lg hover:bg-emerald-800 transition-colors"
          >
            {t("home.products.viewAll")}
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}